// extracted by mini-css-extract-plugin
export default {"tableGrid":"tableGrid___bN7Lr","formTableContainer":"formTableContainer___CtAFy"};